<div class="padding all">
  <div class="spl-key-label">
    <h4>Special Function Key</h4>
  </div>

  <mat-form-field appearance="outline" class="fill" floatLabel="always">
    <mat-label>Key Name</mat-label>
    <input
      type="text"
      (keyup)="keyPress($event)"
      matInput
      [matAutocomplete]="auto"
      [formControl]="form.get('keyName')"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option
        *ngFor="let keyName of filteredSpecialFunctionKeyNames"
        [value]="keyName"
        (onSelectionChange)="setKeyName(keyName)"
      >
        {{ keyName }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="row margin bottom">
    <p class="keyNameMessage" *ngIf="!isKeyNameSelected">
      Key must be selected from drop down. Free form entry not allowed.
    </p>
  </div>
  <div class="row special-actions">
    <button mat-stroked-button class="margin right" [disabled]="!isKeyNameSelected" (click)="onRemoveKey()">
      Remove Key
    </button>
    <button mat-stroked-button [disabled]="!isKeyNameSelected" (click)="onAddKey()">Add Key</button>
  </div>
</div>

<ng-template #successDialogContent>
  <div class="dialog-content dialog-content-success col center">
    <div class="col center padding s8 all">
      <div class="circle-green margin s5 bottom">
        <mat-icon class="success-mark">done</mat-icon>
      </div>

      <h3>{{ message }}</h3>
    </div>
    <div class="actions flex row border top">
      <div class="padding all">
        <button type="button" mat-raised-button color="accent" (click)="dialogRef?.close()">Done</button>
      </div>
    </div>
  </div>
</ng-template>
